export const HEDGE_SECTION_KEY = {
  RATING: "ratings",
  FINANCIALS: "financials",
  GENERAL_INFORMATION: "general-information",
  NEW_HEDGE: "new-hedge"
};
